/** @format */

import axios from 'axios';

import { ENV_COMMON, ENV_COUNTRY } from '../../components/Commons/Hooks/Variables/Enviroment';
import { ScreenWidth } from '../../components/Commons/Hooks/Functions/ScreenWidth';
import { AxiosAdapter } from '../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../_config/v2/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export default async function GetPharmacies(item) {
	console.log('GetPharmacies', item);
	let returnResponse;
	await axios({
		method: 'GET',
		url: `${ENV_COMMON}/pharmacy/${ENV_COUNTRY}/${item}?mobile=${ScreenWidth()}`,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				returnResponse = response.data.data;
			} else {
				throw new Error(response);
			}
		})
		.catch((e) => {
			console.log('error', e);
		});
	return returnResponse;
}

export class Service {
	async getPharmacyCarousel() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_FRONT_COMMON}/corner/${Enviroment.COUNTRY}/${Enviroment.ROOT_PHARMACY}/${Enviroment.ROOT_PHARMACY}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
